import Activiteiten from "../pages/Activiteiten";
import NoMatch from "../pages/NoMatch";
import { Routes, Route } from 'react-router-dom';
import Home from "../pages/Home";
import GebruikerInstellingen from "../pages/GebruikerInstellingen";
import Admin from "../pages/Admin";
import AdminActiviteiten from "./Admin/AdminActiviteiten";
import AdminAppUsers from "./Admin/AdminAppUsers";
import AdminSettings from "./Admin/AdminSettings";
import AdminAanmeldingen from "./Admin/AdminAanmeldingen";
import AdminInfo from "./Admin/AdminInfo";
import AdminUserDetails from "./Admin/AdminUserDetails";
import Aanmelden from "../pages/Aanmelden";
import RequireAuth from "./RequireAuth";
import RequireAARC from "./RequireAARC";
import ResetPassword from "../pages/ResetPassword";


const PageContainer = () => {

    return (
        <div className="pageContainer"> 
            <Routes>
                <Route path='/' element={<Home />}/>
                <Route path='aanmelden' element={<Aanmelden />}/>
                <Route path="activiteiten" element={<RequireAuth><Activiteiten /></RequireAuth>}/>
                <Route path="accountinstellingen" element={<RequireAuth><GebruikerInstellingen /></RequireAuth>}/>
                <Route path="resetpassword/:token" element={<ResetPassword />}/>

                <Route path="admin" element={<RequireAARC><Admin /></RequireAARC>}>


                    <Route index element={<AdminInfo />}/>
                    <Route path="*" element={<AdminInfo />}/>
                    <Route path="info" element={<AdminInfo />}/>
                    <Route path="activiteiten" element={<AdminActiviteiten />}/>
                    <Route path="aanmeldingen" element={<AdminAanmeldingen />}/>
                    <Route path="gebruikers" element={<AdminAppUsers />}>
                        <Route path=":gebruikerId" element={<AdminUserDetails />}/>
                    </Route >
                    <Route path="instellingen" element={<AdminSettings />}/>


                </Route>
                <Route path="*" element={<NoMatch />}/>
            </Routes>
        </div>
    );
}

export default PageContainer;